export const getMentionedUsers = (
  allUserList: any,
  mentionedList: string[],
  plainText: string,
) => {
  const userSet = Array.from(new Set(mentionedList));

  const result = userSet.filter((userId: string) => {
    const userMentioned = allUserList.filter((user: any) => {
      return user.id === userId;
    });
    if (userMentioned.length > 0) {
      if (plainText.indexOf('@' + userMentioned[0].name) >= 0) {
        return true;
      }
    }
    return false;
  });

  return result;
};
